import { ICPlatformVersion } from '@retailer-platform/dashboard/access-control'
import { type DomainAccessControlConfig } from "../utils/domain/accessControl";
import { Permission } from "./permissions";
import { FeatureToggle } from "./featureToggles";

export const externalHealthDashboardAccessControl: DomainAccessControlConfig = {
  warehouseFeatureToggles: [FeatureToggle.externalHealthDashboardFeatureToggles],
  minICPlatformVersion: ICPlatformVersion.r2026_01_0,
  permissions: [Permission.ExternalHealthDashboard],
};
